import _ from "underscore";
import analytics from "web/script/analytics/analytics";
import globals from "web/script/modules/globals";
import browser from "web/script/utils/browser";

/**
 * Checks if an event is the user trying to open something in a new tab
 * @param {MouseEvent} event
 * @returns {boolean}
 */
export function isOpenInNewTab(event) {
    return (browser.mac && event.metaKey) || (!browser.mac && event.ctrlKey);
}

/**
 * A custom hook for tracking analytics events when a link is clicked
 * @param {string} eventCategory The event category
 * @param {string} eventAction The event action
 * @param {string} [eventLabel] Optional free text label for the event.
 * @param {boolean} [delayPageChange] If the click should be delayed until the analytics completes
 * @returns {(event: MouseEvent) => Promise<void>} A callback for onClick
 */
export function useClickTracker(
    eventCategory,
    eventAction,
    eventLabel = "",
    delayPageChange = true
) {
    // TODO: a) shouldn't this be an exception? b) analytics.event already checks this for us
    if (!(_.isString(eventCategory) && _.isString(eventAction))) {
        return () => Promise.resolve();
    }

    function onClick(event) {
        let action = analytics.event(eventCategory, eventAction, eventLabel);
        let openingInNewTab = isOpenInNewTab(event);
        if (delayPageChange && !openingInNewTab) {
            event.preventDefault();
            let href = event.currentTarget.href;
            action = action.then(() => {
                globals.window.location = href;
            });
        }
        return action;
    }
    return onClick;
}
